import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import RichTextConverter from '../../Common/RichText/RichTextConverter';
import * as styles from './Carousel.module.scss';
import ProgressBar from './ProgressBar';

const CarouselListItem = ({
  contentful_id,
  heading,
  description,
  showTimerProgress,
  isSelected,
  rotateRate,
  begin,
  onSelect,
}) => {
  const [dimensions, setDimensions] = useState(
    typeof window !== 'undefined'
      ? { width: window.innerWidth, isMobile: window.innerWidth < 768 }
      : { width: 0, isMobile: false }
  );
  const heightRef = useRef(null);
  const [descriptionHeight, setDescriptionHeight] = useState(0);

  const updateDimensions = () => {
    setDimensions({ width: window.innerWidth, isMobile: window.innerWidth < 768 });
    setDescriptionHeight((heightRef.current?.offsetHeight || 0) + 16);
  };

  useEffect(() => {
    updateDimensions();
    window.addEventListener('resize', updateDimensions);

    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  return (
    <li
      className={[styles.item, isSelected ? styles.selected : ''].join(' ')}
      onClick={() => onSelect(contentful_id)}
      data-analytics-component={'carousel-list-item'}
      data-analytics-id={heading}
    >
      <h4>{heading}</h4>
      <div className={styles.showProgress}>
        <ProgressBar duration={isSelected && showTimerProgress ? rotateRate : 0} starting={begin} />
      </div>
      <div
        style={{ height: isSelected || dimensions.isMobile ? descriptionHeight : 0 }}
        className={[styles.description, isSelected ? styles.open : styles.collapse].join(' ')}
      >
        {description && (
          <div ref={heightRef}>
            <RichTextConverter copy={description} />
          </div>
        )}
      </div>
    </li>
  );
};

CarouselListItem.propTypes = {
  contentful_id: PropTypes.string,
  number: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.object,
  showTimerProgress: PropTypes.bool,
  isSelected: PropTypes.bool,
  rotateRate: PropTypes.number,
  begin: PropTypes.bool,
  onSelect: PropTypes.func,
};

export default CarouselListItem;
